import { DropdownOptions, Flex, TooltipPopup } from 'dash-ui';

import AccountInfo from './components/AccountInfo/AccountInfo';
import ChangeEmail from './components/ChangeEmail/ChangeEmail';
import ChangePassword from './components/ChangePassword/ChangePassword';

function AccountPage() {
  return (
    <Flex flexDirection="column" m={6}>
      <DropdownOptions />
      <TooltipPopup />
      <AccountInfo />
      <ChangeEmail />
      <ChangePassword />
    </Flex>
  );
}

export default AccountPage;
